export const DEFAULT_TINI_VERSION = '0.18.0';

export const DEFAULT_UBUNTU_VERSION = '22.04';

export const DOCKER_IMAGE_PATTERN = /^(?:([^/]+)\/)?(?:([^/]+)\/)?([^/:@]+)(?:[:@](.+))?$/;
